<div class="card bg-white relative border-none">
  <div class="card-header p-5 pb-0">
    <div class="flex items-center justify-between">
      <p class="flex mb-0 pb-0 text-primaryDark text-lg sm:text-xl font-bold">{{ data.title }}</p>
      <button (click)="close()" class="btn border-transparent shadow-none text-gray hover:text-grayDark fadeInFadeOut">
        <i class="fas fa-times text-lg"></i>
      </button>
    </div>
  </div>

  <div class="card-content">
    <p *ngIf="data.intro" class="text-grayDark leading-normal text-sm mb-4">{{ data.intro }}</p>

    <ol class="list-none m-0 p-0">
      <li *ngFor="let step of data.steps; let i = index" class="flex flex-row items-start mb-4">
        <span class="flex-shrink-0 w-8 h-8 min-w-8 aspect-square rounded-full bg-primary text-white flex items-center justify-center text-sm font-bold leading-none mr-3">{{ i + 1 }}</span>
        <div class="flex flex-col">
          <span class="text-black font-medium text-sm">{{ step.label }}</span>
          <span class="text-grayDark leading-normal text-sm">{{ step.text }}</span>
        </div>
      </li>
    </ol>

    <div *ngIf="data.warning"
         class="flex flex-row items-start p-4 rounded border-orange bg-orangeWashed border text-orange text-sm leading-normal mt-2">
      <i class="fas fa-exclamation-triangle mr-2 mt-1"></i>
      <span>{{ data.warning }}</span>
    </div>
  </div>

  <div class="card-content">
    <div class="flex flex-row justify-between items-center">
      <button *ngIf="data.showFeedback" class="btn btn-grayDark-link" (click)="feedback()">
        <i class="fas fa-comment-dots mr-2"></i><span i18n>Povratna informacija</span>
      </button>
      <span *ngIf="!data.showFeedback"></span>
      <button class="btn btn-primary" (click)="confirm()">
        <ng-container *ngIf="data.confirmLabel; else defaultLabel">
          <i class="fas fa-upload mr-2"></i>{{ data.confirmLabel }}
        </ng-container>
        <ng-template #defaultLabel><span i18n>Razumem</span></ng-template>
      </button>
    </div>
  </div>
</div>
